export default "__VITE_ASSET__95fc7e85__"